import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { CheckCircle, ArrowRight } from '@phosphor-icons/react';

const POLL_INTERVAL = 2000;
const MAX_POLLS = 30;

const TrinketSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [state, setState] = useState({ status: 'checking', payment_status: 'pending', user_trinket: null });
  const attempts = useRef(0);
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      if (attempts.current >= MAX_POLLS) { setState((s) => ({ ...s, status: 'timeout' })); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/trinkets/checkout/status/${sessionId}`);
        if (cancelled) return;
        setState(data);
        if (data.payment_status === 'paid' && data.user_trinket) return;
        if (data.status === 'expired') return;
        setTimeout(poll, POLL_INTERVAL);
      } catch {
        setTimeout(poll, POLL_INTERVAL);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const paid = state.payment_status === 'paid' && state.user_trinket;
  const ut = state.user_trinket;

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-8 py-16 text-center">
      {!paid ? (
        <>
          <div className="h-24 w-24 mx-auto rounded-full bg-gradient-to-br from-bx-cyan via-bx-magenta to-bx-volt breathe" />
          <h1 className="font-display text-3xl sm:text-5xl font-black tracking-tighter mt-6">
            Engraving your trinket…
          </h1>
          <p className="text-white/60 mt-2 text-sm">Confirming payment.</p>
        </>
      ) : (
        <div className="pop-in">
          <CheckCircle size={48} weight="fill" className="text-bx-volt mx-auto" />
          <h1 className="font-display text-3xl sm:text-5xl font-black tracking-tighter mt-4">
            <span className="shimmer-text">{ut.name}</span> is yours.
          </h1>
          <div className="my-8 text-7xl">{ut.emoji}</div>
          <div className="chip mx-auto"><span className={`rar-${ut.rarity}`}>{ut.rarity}</span> · {ut.kind}</div>
          <p className="text-white/65 mt-4">
            {ut.kind === 'trinket'
              ? 'Equipped to your bubble. Visible on every transfer.'
              : 'Pinned to your profile. Visible on the feed and leaderboards.'}
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <button data-testid="trinket-success-profile" onClick={() => nav('/profile')} className="btn-primary px-6 py-3 rounded-full text-sm flex items-center gap-2">
              View profile <ArrowRight size={14} weight="bold" />
            </button>
            <Link to="/trinkets" data-testid="trinket-success-more" className="px-6 py-3 rounded-full glass-hi text-sm font-bold hover:bg-white/10 transition">
              Browse more
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrinketSuccess;
